import React, { useState } from "react";
import {
  IconRobot,
  IconArrowLeft,
  IconArrowRight,
  IconSend,
  IconMessageCircle,
} from "@tabler/icons-react";
import SectionCard from "./SectionCard";

import { ChatMessage } from "../../store/@types/portal";
import TextInput from "../elements/form/TextInput";
import Button from "../elements/form/Button";

type AIAssistantStepProps = {
  messages: ChatMessage[];
  busy?: boolean;
  onSendMessage: (content: string) => void;
  onBack: () => void;
  onContinue: () => void;
};
const AIAssistantStep: React.FC<AIAssistantStepProps> = ({
  messages,
  busy,
  onSendMessage,
  onBack,
  onContinue,
}) => {
  const [draft, setDraft] = useState("");

  const handleSend = () => {
    if (!draft.trim() || busy) return;
    onSendMessage(draft.trim());
    setDraft("");
  };

  return (
    <SectionCard
      icon={<IconRobot size={20} stroke={1.75} />}
      title="AI Compliance Assistant"
    >
      <div className="mt-6 flex h-[450px] flex-col rounded-xl border border-gray-100/20">
        <div className="flex-1 space-y-3 overflow-y-auto px-5 py-5">
          {messages.length === 0 ? (
            <div className="flex h-full flex-col items-center justify-center text-center text-slate-400">
              <IconMessageCircle size={32} stroke={1.5} />
              <p className="mt-3 text-sm">
                Ask me anything about African corporate compliance!
              </p>
            </div>
          ) : (
            messages.map((message) => (
              <div
                key={message.id}
                className={
                  message.role === "user"
                    ? "ml-auto max-w-[80%] rounded-2xl rounded-br-sm bg-primary-500 px-4 py-2 text-sm lg:text-base text-white"
                    : "mr-auto max-w-[80%] rounded-2xl rounded-bl-sm bg-gray-50/20 px-4 py-2 text-sm lg:text-base text-black"
                }
              >
                {message.content}
              </div>
            ))
          )}
        </div>

        <div className="border-t border-gray-100/20 px-4 py-3">
          <TextInput
            name="chatDraft"
            type="text"
            value={draft}
            placeholder="Ask about compliance, regulations or documentation..."
            required={false}
            onChange={(e) => setDraft(e.target.value)}
            right_icon={<IconSend size={16} />}
            onRightIconClick={handleSend}
          />
        </div>
      </div>

      <div className="flex items-center justify-between pt-6">
        <Button
          title="Back"
          type="button"
          onHandler={onBack}
          icon={<IconArrowLeft size={18} />}
          bg_color="bg-white"
          bg_hoverColor="bg-slate-50"
          text_color="text-slate-700"
          className="rounded-full border border-slate-200"
        />
        <Button
          title="Continue to Generate Documents"
          type="button"
          onHandler={onContinue}
          rightIcon={<IconArrowRight size={18} />}
          bg_color="bg-primary-500"
          bg_hoverColor="bg-primary-600"
          className="rounded-full"
        />
      </div>
    </SectionCard>
  );
};

export default AIAssistantStep;
